import React from 'react';
import { useNavigate } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { CloudfrontVideoFormat } from '../videos/CloudfrontVideoFormat';
import './welcomeVideo.scss';

/**
 * Plays a video at the very start of each module. Note that this will only be shown on
 * the first day and all subsequent days will not show it.
 * @param {*} props
 * @returns
 */
const WelcomeVideo = (props) => {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const navigate = useNavigate();
  return (
    <div className='welcome-video'>
      <CloudfrontVideoFormat
        source={props.welComeVideo}
        back='/unit1'
        background={props.background}
        token={login.cookie}
        close={props.closeWelcome}
        ended={() => {
          navigate(props.destiny);
        }}
      />
    </div>
  );
};
export default WelcomeVideo;
